import React, { useEffect, useState } from "react";
import "./SitePreview.css";

// A minimal browser window that embeds the live site in an iframe so visitors
// can scroll and navigate it in place. The full-page screenshot is used as a
// loading poster, and as a fallback for sites that refuse to be framed.
const SitePreview = ({ src, url, alt }) => {
  const [status, setStatus] = useState("loading"); // loading | loaded | blocked
  const display = url.replace(/^https?:\/\//, "").replace(/\/$/, "");

  useEffect(() => {
    // if the frame never signals load, assume it is blocked and show fallback
    const t = setTimeout(() => {
      setStatus((s) => (s === "loading" ? "blocked" : s));
    }, 6000);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="site-preview">
      <div className="site-preview-bar">
        <div className="site-preview-dots">
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div className="site-preview-url">
          <p>{display}</p>
        </div>
        <a
          className="site-preview-open"
          href={url}
          target="_blank"
          rel="noreferrer"
        >
          open &#8599;
        </a>
      </div>
      <div className="site-preview-window">
        <iframe
          className="site-preview-frame"
          src={url}
          title={alt}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          onLoad={() => setStatus("loaded")}
        ></iframe>

        {status !== "loaded" && (
          <div
            className={
              status === "blocked"
                ? "site-preview-poster is-blocked"
                : "site-preview-poster"
            }
            style={{ backgroundImage: `url(${src})` }}
          >
            {status === "blocked" && (
              <a
                className="site-preview-fallback"
                href={url}
                target="_blank"
                rel="noreferrer"
              >
                open live site &#8599;
              </a>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default SitePreview;
